// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Lamentations",
  bookSlug: "lamentations",
  chapter: 5,
  argument: "THE PRAYER OF JEREMIAS, THE PROPHET.",
  verses: [
    { n: 1, text: "Remember, O Lord, what is come upon us: consider and behold our reproach." },
    { n: 2, text: "Our inheritance is turned to aliens: our houses to strangers." },
    { n: 3, text: "We are become orphans without a father: our mothers are as widows." },
    { n: 4, text: "We have drunk our water for money: we have bought our wood." },
    { n: 5, text: "We were dragged by the necks, we were weary, and no rest was given us." },
    { n: 6, text: "We have given our hand to Egypt, and to the Assyrians, that we might be satisfied with bread." },
    { n: 7, text: "Our fathers have sinned, and are not: and we have borne their iniquities." },
    { n: 8, text: "Servants have ruled over us: there was none to redeem us out of their hand." },
    { n: 9, text: "We fetched our bread at the peril of our lives, because of the sword in the desert." },
    { n: 10, text: "Our skin was burnt as an oven, by reason of the violence of the famine." },
    { n: 11, text: "They oppressed the women in Sion, and the virgins in the cities of Juda." },
    { n: 12, text: "The princes were hanged up by their hand: they did not respect the persons of the ancients." },
    { n: 13, text: "They abused the young men indecently: and the children fell under the wood." },
    { n: 14, text: "The ancients have ceased from the gates: the young men from the choir of the singers." },
    { n: 15, text: "The joy of our heart is ceased, our dancing is turned into mourning." },
    { n: 16, text: "The crown is fallen from our head: woe to us, because we have sinned." },
    { n: 17, text: "Therefore is our heart sorrowful, therefore are our eyes become dim." },
    { n: 18, text: "For Mount Sion, because it is destroyed, foxes have walked upon it." },
    { n: 19, text: "But thou, O Lord, shalt remain for ever, thy throne from generation to generation." },
    { n: 20, text: "Why wilt thou forget us for ever? why wilt thou forsake us for a long time?" },
    { n: 21, text: "Convert us, O Lord, to thee, and we shall be converted: renew our days, as from the beginning." },
    { n: 22, text: "But thou hast utterly rejected us, thou art exceedingly angry with us." },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "The prayer, &c. This title is not in Hebrew, Septuagint, &c. Theodoret has passed over the chapter, as if he doubted of its authenticity. It does not follow the order of Hebrew letters like the preceding, and seems to be a form of prayer for those who retired into Egypt. (Calmet) — Jeremias foresees what would happen, and prays as the people would do.", attribution: "Worthington" }
    ] },
    { verse: 2, notes: [
      { text: "Aliens. The Idumeans seized and kept possession of the southern parts.", attribution: "Haydock" }
    ] },
    { verse: 3, notes: [
      { text: "Father. Many had none surviving, and all had lost their king.", attribution: "Worthington" }
    ] },
    { verse: 4, notes: [
      { text: "Water. Even this was not given for nothing.", attribution: "Haydock" }
    ] },
    { verse: 6, notes: [
      { text: "Hand; engaged to serve Egyptians, Babylonians, (Calmet) or other nations, to procure sustenance.", attribution: "Worthington" }
    ] },
    { verse: 7, notes: [
      { text: "Iniquities. This was the usual complaint of the Jews, (chap. xxxi. 29.) as if they had committed no offence themselves. If any virtuous people were involved in the common ruin, they bore it with resignation, and acknowledged that they had deserved it, 1 Esdras ix. 6., and 2 Esdras i. 6., and Esther xiv. 6., and Daniel iii. 29.", attribution: "Haydock" }
    ] },
    { verse: 8, notes: [
      { text: "Servants. One had command over another, Matthew xxiv. 45. The Chaldeans were like slaves, and the race of Cham was condemned to servitude, Genesis ix. 26. (Calmet) — The Jews had formerly dominion over Edom, &c., who now treated them so cruelly. (Menochius)", attribution: "Lyranus" }
    ] },
    { verse: 9, notes: [
      { text: "Sword. Any one might kill us.", attribution: "Haydock" }
    ] },
    { verse: 11, notes: [
      { text: "Oppressed. Hebrew, \"afflicted.\" Brutal insolence prevailed.", attribution: "Calmet" }
    ] },
    { verse: 12, notes: [
      { text: "Hand. Thus Leonidas was treated, after his head was cut off, by Xerxes.", attribution: "Herodotus vii. 238." }
    ] },
    { verse: 13, notes: [
      { text: "Indecently, like the Sodomites. Hebrew, \"they made the young men grind\" at the mill, in their prison, (Haydock) as Samson (Judges xvi. 21.) and Sedecias (according to the Septuagint, chap. lii. 11.) were forced to do. To grind is often used in a bad sense; but it is not necessary to adopt it here. (Calmet) (Amama) — The Chaldeans treated their captives without pity or shame. (Haydock) — Wood; burdens, or stumbling-blocks, unless they were crucified; or, \"roasted,\" if we admit a small alteration in the Hebrew, chap. iv. 10. (Calmet) — They were forced to grind naked, and were beaten with staves.", attribution: "Worthington" }
    ] },
    { verse: 14, notes: [
      { text: "Gates, where sentence was usually passed. (Haydock) — The Jews had judges at Babylon, (Daniel xiii. 5.) but not at first, nor everywhere.", attribution: "Haydock" }
    ] },
    { verse: 16, notes: [
      { text: "Crown, used at feasts; (Calmet) or, we have lost the sovereign power.", attribution: "Worthington" }
    ] },
    { verse: 17, notes: [
      { text: "Dim, the natural consequence of extreme want, 1 Kings xiv. 27.", attribution: "Haydock" }
    ] },
    { verse: 18, notes: [
      { text: "Foxes, which were very common, Judges xv. 4. Thus, Horace says: Agros atque lares patrios, habitandaque fana Apris relinquet et edacibus lupis.", attribution: "Epod. 16." }
    ] },
    { verse: 21, notes: [
      { text: "Convert. Thy grace must work upon our hearts, (Calmet) before we can expect redress, (Haydock) and an end of our banishment. (Tirinus) (Grotius) — Beginning, when our fathers observed the law. (St. Thomas Aquinas) (Menochius) See chap. xxxi. 18.; St. Augustine, City of God ii., and iv.", attribution: "Worthington" }
    ] },
    { verse: 22, notes: [
      { text: "Thou hast. We might read with an interrogation, (Haydock) in Hebrew, \"Hast thou?\" &c. The Jews superstitiously repeat the last verse, for fear of ending the book in an ominous manner, as they do at the end of Isaias and Malachias. (Calmet) — Having treated us so severely, stop thy hand. (Worthington) — But I perceive it will be in vain to beg for redress till the seventy years be expired.", attribution: "Menochius" }
    ] },
  ],
};

export default chapter;
